import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import {
	StyledPaper,
	StyledThumbnailPaper,
} from '@styles/alt-text-form.styles';

const ImagePreview = ({ element, isThumbnail = false }) => {
	const previewRef = useRef(null);

	useEffect(() => {
		if (!element || !previewRef.current) {
			return;
		}

		// Only allow previewing safe elements
		const tag = element.tagName.toLowerCase();
		const allowedTags = ['img', 'svg'];

		if (!allowedTags.includes(tag)) {
			return;
		}

		const clone = element.cloneNode(true); // Deep clone

		// Remove inline styles from the cloned element
		clone.removeAttribute('style');
		clone.style.cssText = '';
		clone.setAttribute('role', 'presentation');

		previewRef.current.innerHTML = ''; // Clear previous
		previewRef.current.appendChild(clone);
	}, [element]);

	if (isThumbnail) {
		return (
			<StyledThumbnailPaper
				color="secondary"
				elevation={0}
				square
				ref={previewRef}
			/>
		);
	}

	return (
		<StyledPaper color="secondary" elevation={0} square ref={previewRef} />
	);
};

ImagePreview.propTypes = {
	isThumbnail: PropTypes.bool,
	element: PropTypes.instanceOf(Node).isRequired,
};

export default ImagePreview;
